export default __webpack_public_path__ + "static/media/instrucciones-7.090c44e2.jpg";